<form #deputyAreaForm="ngForm" novalidate class="form-v2">
    <div class="modal-header">
        <h3 class="modal-title">Manage Deputy Areas</h3>
    </div>
    <div class="modal-body">
        <div class="form-group row new">
            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Category</th>
                            <th>Deputy Area</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of jobParentItems" id="itemRow{{ item.ID_JobItem }}">
                            <td class="condensed-col">
                                <span>{{ item.Description }}</span>
                            </td>
                            <td>
                                <ng-select
                                    [(ngModel)]="item.TimesheetCategoryId"
                                    [ngModelOptions]="{ standalone: true }"
                                    [items]="deputyAreaList"
                                    class="light"
                                    (change)="setDeputyAreaId($event)"
                                    bindLabel="OperationalUnitName"
                                    bindValue="Id"
                                    [disabled]="!!item.TimesheetCategoryId">
                                    <ng-template ng-label-tmp let-item="item">
                                        {{ item.OperationalUnitName }}
                                    </ng-template>
                                    <ng-template ng-option-tmp let-item="item">
                                        {{ item.OperationalUnitName }}
                                    </ng-template>
                                </ng-select>
                            </td>
                            <td>
                                <button
                                    type="button"
                                    class="btn btn-primary-bxt"
                                    style="width: 150px"
                                    *ngIf="!item.TimesheetCategoryId"
                                    (click)="createDeputyArea(item)">
                                    Create Deputy Area
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-default-bxt"
                                    style="width: 150px"
                                    *ngIf="item.TimesheetCategoryId"
                                    (click)="unlinkDeputyArea(item)">
                                    Unlink
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div class="modal-footer new">
        <button type="button" class="btn btn-primary-bxt" (click)="ok()">Close</button>
    </div>
</form>
